export function getdata() {
	var obj = {
		headData: [{
				title: "调整时间",
				prop: "updateTime",
				custom: true,
				width: 160,
			},
			{
				title: "调整人",
				prop: "updateBy",
				custom: true,
				width: "80",
			},
			{
				title: "调整说明",
				prop: "beizsm",
				custom: true,
				width: 160,
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				width: "200"
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
